import { STOPWORDS } from "./stopwords";

export function removeStopwords(text) {
  var words;
  if (text) {
    words = text
      .toLowerCase()
      .match(/\b\w+\b/g)
      .filter((word) => !STOPWORDS.includes(word));
  }
  return words;
}
